import { jsx as _jsx } from "react/jsx-runtime";
import ScriptKeys from '@constants/script-keys';
import { createIcomoonStyleSheet } from '@helpers/icomoon';
import { getValueFromVariables } from '@helpers/variables';
var IcomoonStyleScript = function (props) {
    var variables = props.variables;
    var icomoonVersion = variables
        ? getValueFromVariables(variables, ScriptKeys.ICOMOON_VERSION)
        : undefined;
    var versionValue = icomoonVersion ? "?".concat(icomoonVersion === null || icomoonVersion === void 0 ? void 0 : icomoonVersion.value) : '';
    return (_jsx("script", { defer: true, id: "icomoon-style-script", dangerouslySetInnerHTML: {
            __html: "\n        window.addEventListener('DOMContentLoaded', () => {\n          ".concat(createIcomoonStyleSheet(versionValue), "\n        });\n        ")
        } }));
};
export default IcomoonStyleScript;
